import React from 'react'
import { colors } from '../../../consts'
import { CustomSelect } from '../CustomSelect'

type PosSelectProps = {
  current: string
  defaultVal: string
  list: SelectListItem[]
  onSelectChange?: (val: string) => void
  color?: string
  size?: 'sm' | 'md' | 'lg'
}

export type SelectListItem = {
  label: string
  value: number | string
}

export const GeneralSelect: React.FC<React.PropsWithChildren<PosSelectProps>> = ({
  current,
  list,
  onSelectChange,
  color = colors.yellow,
  size = 'sm',
}) => {
  const value = current
  const onChange = (option: string) => {
    if (onSelectChange) {
      onSelectChange(option)
    }
  }

  return (
    <CustomSelect
      options={list.map((l) => l.label)}
      value={value}
      onChange={onChange}
      id="general-select"
      ariaLabel={`General select ${value}`}
      color={color}
      size={size}
    />
  )
}

